export default __webpack_public_path__ + "static/media/bg3_1_m.d21db4f4.png";